/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Jan 29 2021 10:27:36 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.DISPLAY_FRAMEWORK;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface CompDisplayResponse {
  comcode: string;
  comformat: string;
  comhint: string;
  comid: number;
  comlabel: string;
  commessage: string;
  complaceholder: string;
  comstyle: string;
  comtype: string;
  flaghide: boolean;
  flagrequired: boolean;
  flagdisabled: boolean;
  pagcode?: string;
}

export interface MenusDisplayResponse {
  itemid: number;
  itemidparent: number;
  itemlabel: string;
  itemorder: number;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagparams: string;
  pagurl: string;
  pitemid: number;
}

export interface MenusItemRequest {
  itemid: number;
  itemidparent: number;
  itemlabel: string;
  itemorder: number;
  menuicon: string;
  menuid: number;
  pagcode?: string;
  pagparams: string;
  pitemid: number;
}

export interface MenusItemResponse {
  itemid: number;
  itemidparent: number;
  itemlabel: string;
  itemorder: number;
  menuicon: string;
  menuid: number;
  pagcode?: string;
  paglabel: string;
  pagparams: string;
  pagurl: string;
  pitemid: number;
}

export interface MenusRequest {
  menudescription: string;
  menuid: number;
  menulabel: string;
  menusItems: Array<MenusItemRequest>;
  menusRoles: Array<MenusRolesRequest>;
  menusUsers: Array<MenusUsersRequest>;
  menustatus: string;
}

export interface MenusResponse {
  menudescription: string;
  menuid: number;
  menulabel: string;
  menusItems: Array<MenusItemResponse>;
  menusRoles: Array<MenusRolesResponse>;
  menusUsers: Array<MenusUsersResponse>;
  menustatus: string;
  statuslabel: string;
  lancode?: string;
  lancodelabel?: string;
}

export interface MenusRolesRequest {
  associd: number;
  menuid: number;
  rolcode: string;
}

export interface MenusRolesResponse {
  associd: number;
  menuid: number;
  rolcode: string;
  rolelabel: string;
}

export interface MenusUsersRequest {
  associd: number;
  menuid: number;
  userid: number;
}

export interface MenusUsersResponse {
  associd: number;
  menuid: number;
  name: string;
  userid: number;
  username: string;
}

export interface ParList {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parflagdefault: boolean;
  parlistlabel: string;
  parmodule: string;
  parvalue: string;
  parvalueparent: string;
}

export interface ParPagComFilteringRequest {
  comcode: string;
  comlabel: string;
  flaghide: boolean;
  flagrequired: boolean;
  flagdisabled: boolean;
}

export interface ParPagComFilteringResponse {
  comcode: string;
  comfilterid: number;
  comlabel: string;
  flaghide: boolean;
  flagrequired: boolean;
  flagdisabled: boolean;
}

export interface ParPagComponentRequest {
  comcode: string;
  comformat: string;
  comhint: string;
  comlabel: string;
  commessage: string;
  complaceholder: string;
  comrequired: boolean;
  comstyle: string;
  comtype: string;
  pagcode?: string;
}

export interface ParPagComponentResponse {
  comcode: string;
  comformat: string;
  comhint: string;
  comid: number;
  comlabel: string;
  commessage: string;
  complaceholder: string;
  comrequired: boolean;
  comstyle: string;
  comtype: string;
  pagcode?: string;
}

export interface ParPagFilteringRequest {
  filterdescription: string;
  mgid: number;
  parPagComFilterings: Array<ParPagComFilteringRequest>;
  userid: number;
  userrole: string;
  flagcreationmode: boolean;
  objecttype: string;
  objectphase: string;
  objectstatus: string;
  prcode: string;
  prioritylevel: number;
}

export interface ParPagFilteringResponse {
  filterdescription: string;
  filterid: number;
  mgid: number;
  parPagComFilterings: Array<ParPagComFilteringResponse>;
  rolelabel: string;
  userid: number;
  username: string;
  userrole: string;
  flagcreationmode: boolean;
  objecttype: string;
  objectphase: string;
  objectstatus: string;
  prcode: string;
  prioritylevel: number;
}

export interface ParPageListResponse {
  flaglanding: boolean;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
  pagmodulelabel:string;
}

export interface ParPageRequest {
  flaglanding: boolean;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
  parPagComponents: Array<ParPagComponentRequest>;
  parPagFilterings: Array<ParPagFilteringRequest>;
}

export interface ParPageResponse {
  flaglanding: boolean;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
  parPagComponents: Array<ParPagComponentResponse>;
  parPagFilterings: Array<ParPagFilteringResponse>;
}

export interface UserResponse {
  name: string;
  userid: number;
  username: string;
}

export interface ViewMenus {
  menudescription: string;
  menuid: number;
  menulabel: string;
  menustatus: string;
  menuRoles: any;
}

export interface GetParListParams {
  parcode?: string;
}

export interface GetMenusByUserIdParams {
  userid: number;
}

export interface NewParPageResponse {
  flaglanding: boolean;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
};

export interface NewParPageRequest {
  flaglanding: boolean;
  pagcode?: string;
  pagicon: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
};

export interface NewParPagComponentResponse {
  comcode: string;
  comformat: string;
  comhint: string;
  comid: number;
  comlabel: string;
  commessage: string;
  complaceholder: string;
  comrequired: boolean;
  comstyle: string;
  comtype: string;
  pagcode?: string;
};


export interface NewParPagComponentRequest {
  comcode: string;
  comformat: string;
  comhint: string;
  comlabel: string;
  commessage: string;
  complaceholder: string;
  comrequired: boolean;
  comstyle: string;
  comtype: string;
  pagcode?: string;
};


export interface NewParPagComFilteringRequest {
  comcode: string;
  comlabel: string;
  filterid: number;
  flagdisabled: boolean;
  flaghide: boolean;
  flagrequired: boolean;
};
      
  
  
export interface NewParPagComFilteringResponse {
  comcode: string;
  comfilterid: number;
  comlabel: string;
  filterid: number;
  flagdisabled: boolean;
  flaghide: boolean;
  flagrequired: boolean;
};
   

export interface NewParPagFilteringResponse {
  filterdescription: string;
  filterid: number;
  flagcreationmode: boolean;
  mgid: number;
  objectphase: string;
  objectstatus: string;
  objecttype: string;
  pagcode?: string;
  prcode: string;
  prioritylevel: number;
  rolelabel: string;
  userid: number;
  username: string;
  userrole: string;
};

export interface NewParPagFilteringRequest {
  filterdescription: string;
  filterid: number;
  flagcreationmode: boolean;
  mgid: number;
  objectphase: string;
  objectstatus: string;
  objecttype: string;
  pagcode?: string;
  prcode: string;
  prioritylevel: number;
  rolelabel: string;
  userid: number;
  username: string;
  userrole: string;
};

export interface ParTheme {
  bordercolor: string;
  fontface: string;
  linkcolor: string;
  logo: string;
  primarycolor: string;
  primarycolorlight: string;
  secondarycolor: string;
  textcolor: string;
  themeid: number;
  themename: string;
}


/**
 * @tags Menus Item Controller
 * @summary getMenusByUserId
 */
export function getMenusByUserId(params: GetMenusByUserIdParams) {
  return request.get<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menususers/user/${params.userid}`
  );
}
export interface AddMenusitemParams {
  isAfter: boolean;
  isBefore: boolean;
  isChild: boolean;
  menuRequest: MenusItemRequest;
  itemid: number;
}

/**
 * @tags Menus Item Controller
 * @summary addMenusitem
 */
export function addMenusitem(params: AddMenusitemParams) {
  return request.post<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menuitems` +
      prepareQueryParams({
        isAfter: params.isAfter,
        isBefore: params.isBefore,
        isChild: params.isChild,
        itemid: params.itemid,
      } as any),
    params.menuRequest
  );
}

export interface UpdateMenusitemParams {
  menuRequest: MenusItemRequest;
  pitemid: number;
}

/**
 * @tags Menus Item Controller
 * @summary UpdateMenusitem
 */
export function UpdateMenusitem(params: UpdateMenusitemParams) {
  return request.put<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menuitems/${params.pitemid}`,
    params.menuRequest
  );
}

export interface DeleteMenusitemParams {
  pitemid: number;
}

/**
 * @tags Menus Item Controller
 * @summary deleteMenusitem
 */
export function deleteMenusitem(params: DeleteMenusitemParams) {
  return request.delete<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menuitems/${params.pitemid}`
  );
}
export interface GetListMenusrolesParams {
  menuid: number;
}

/**
 * @tags Menus Item Controller
 * @summary getListMenusroles
 */
export function getListMenusroles(params: GetListMenusrolesParams) {
  return request.get<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menusroles/${params.menuid}`
  );
}
export interface AddMenusrolesParams {
  menuRequest: MenusRolesRequest;
}

/**
 * @tags Menus Item Controller
 * @summary addMenusroles
 */
export function addMenusroles(params: AddMenusrolesParams) {
  return request.post<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menusroles`,
    params.menuRequest
  );
}
export interface RemoveMenusrolesParams {
  associd: number;
}
/**
 * @tags Menus Item Controller
 * @summary removeMenusroles
 */
export function removeMenusroles(params: RemoveMenusrolesParams) {
  return request.delete<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menusroles/${params.associd}`
  );
}

export interface GetListMenususersParams {
  menuid: number;
}

/**
 * @tags Menus Item Controller
 * @summary getListMenususers
 */
export function getListMenususers(params: GetListMenususersParams) {
  return request.get<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menususers/${params.menuid}`
  );
}

export interface AddMenususersParams {
  menuRequest: MenusUsersRequest;
}

/**
 * @tags Menus Item Controller
 * @summary addMenususers
 */
export function addMenususers(params: AddMenususersParams) {
  return request.post<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menususers`,
    params.menuRequest
  );
}

export interface RemoveMenususersParams {
  associd: number;
}

/**
 * @tags Menus Item Controller
 * @summary removeMenususers
 */
export function removeMenususers(params: RemoveMenususersParams) {
  return request.delete<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menususers/${params.associd}`
  );
}

/**
 * @tags Menus Item Controller
 * @summary getParList
 */
export function getParList(params: GetParListParams) {
  return request.get<AbstractResponse<unknown, ParList>>(
    `${URL}/api/getParList` +
      prepareQueryParams({ parcode: params.parcode } as any)
  );
}

export interface GetUsersByCriteriaParams {
  name: string;
  username: string;
}

/**
 * @tags Menus Item Controller
 * @summary getUsersByCriteria
 */
export function getUsersByCriteria(params: GetUsersByCriteriaParams) {
  return request.get<AbstractResponse<unknown, UserResponse>>(
    `${URL}/api/getUsersByCriteria` +
      prepareQueryParams({
        name: params.name,
        username: params.username,
      } as any)
  );
}

export interface GetMenusByLabelParams {
  menulabel?: string;
  menustatus?: string;
  rolcode?: string;
  menuid?: number;
}

/**
 * @tags Menus Item Controller
 * @summary getMenusByLabel
 */
export function getMenusByLabel(params: GetMenusByLabelParams) {
  return request.get<AbstractResponse<unknown, ViewMenus>>(
    `${URL}/api/menus` +
      prepareQueryParams({
        menulabel: params.menulabel,
        menustatus: params.menustatus,
        rolcode: params.rolcode,
        menuid: params.menuid,
      } as any)
  );
}

export interface DuplicateMenusByMenuIdParams {
  label: string;
  menuid: number;
}

/**
 * @tags Menus Item Controller
 * @summary duplicateMenusByMenuId
 */
export function duplicateMenusByMenuId(params: DuplicateMenusByMenuIdParams) {
  return request.post<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/duplicate/${params.menuid}` +
      prepareQueryParams({ label: params.label } as any)
  );
}

export interface CreateMenusParams {
  menusRequest: MenusRequest;
}

/**
 * @tags Menus Item Controller
 * @summary createMenus
 */
export function createMenus(params: CreateMenusParams) {
  return request.post<AbstractResponse<MenusResponse, unknown>>(
    `${URL}/api/menus`,
    params.menusRequest
  );
}

export interface GetMenuDetailParams {
  menuid: number;
}

/**
 * @tags Menus Item Controller
 * @summary getMenuDetail
 */
export function getMenuDetail(params: GetMenuDetailParams) {
  return request.get<AbstractResponse<MenusResponse, unknown>>(
    `${URL}/api/menus/${params.menuid}`
  );
}

export function getMenuTreeDetail(params: GetMenuDetailParams) {
  return request.get<AbstractResponse<MenusResponse, unknown>>(
    `${URL}/api/menusTree/${params.menuid}`
  );
}

export interface UpdateMenusParams {
  menuid: number;
  menusRequest: MenusRequest;
}

/**
 * @tags Menus Item Controller
 * @summary updateMenus
 */
export function updateMenus(params: UpdateMenusParams) {
  return request.put<AbstractResponse<MenusResponse, unknown>>(
    `${URL}/api/menus/${params.menuid}`,
    params.menusRequest
  );
}

export interface UpdateMenuStatusParams {
  menuid: number;
  status: string;
}

/**
 * @tags Menus Item Controller
 * @summary updateMenuStatus
 */
export function updateMenuStatus(params: UpdateMenuStatusParams) {
  return request.put<AbstractResponse<MenusResponse, unknown>>(
    `${URL}/api/menus/${params.menuid}/status/${params.status}`
  );
}

/**
 * @tags Menus Item Controller
 * @summary getCurrentUserMenu
 */
export function getCurrentUserMenu() {
  return request.get<AbstractResponse<unknown, MenusDisplayResponse>>(
    `${URL}/api/myMenus`
  );
}

export interface GetCurrentPageDisplayParams {
  pagcode?: string;
  entity?: string;
  entityid?: number;
}

/**
 * @tags Fw Display Controller
 * @summary getCurrentPageDisplay
 */
export function getCurrentPageDisplay(params: GetCurrentPageDisplayParams) {
  return request.get<AbstractResponse<unknown, CompDisplayResponse>>(
    `${URL}/api/myPageDisplay` +
      prepareQueryParams({
        pagcode: params.pagcode,
        entity: params.entity,
        entityid: params.entityid,
      } as any)
  );
}

export interface GetPagesByCriteriaParams {
  pagcode?: string;
  paglabel?: string;
}

/**
 * @tags Fw Display Controller
 * @summary getPagesByCriteria
 */
export function getPagesByCriteria(params: GetPagesByCriteriaParams) {
  return request.get<AbstractResponse<unknown, ParPageListResponse>>(
    `${URL}/api/pages` +
      prepareQueryParams({
        pagcode: params.pagcode,
        paglabel: params.paglabel,
      } as any)
  );
}

export interface CreatePageParams {
  pageRequest: ParPageRequest;
}

/**
 * @tags Fw Display Controller
 * @summary createPage
 */

export function createPage(params: CreatePageParams) {
  return request.post<AbstractResponse<ParPageResponse, unknown>>(
    `${URL}/api/pages`,
    params.pageRequest
  );
}

export interface GetLandingPagesByCriteriaParams {
  pagcode?: string;
  paglabel?: string;
}

/**
 * @tags Fw Display Controller
 * @summary getLandingPagesByCriteria
 */
export function getLandingPagesByCriteria(
  params: GetLandingPagesByCriteriaParams
) {
  return request.get<AbstractResponse<unknown, ParPageListResponse>>(
    `${URL}/api/pages/landing` +
      prepareQueryParams({
        pagcode: params.pagcode,
        paglabel: params.paglabel,
      } as any)
  );
}

export interface GetPageDetailParams {
  pagcode?: string;
}

/**
 * @tags Fw Display Controller
 * @summary getPageDetail
 */
export function getPageDetail(params: GetPageDetailParams) {
  return request.get<AbstractResponse<ParPageResponse, unknown>>(
    `${URL}/api/pages/${params.pagcode}`
  );
}

export interface UpdatePageParams {
  pagcode?: string;
  pageRequest: ParPageRequest;
}

export interface UpdatePagComponentParams {
  request: ParPagComponentRequest;
}

/**
 * @tags Fw Display Controller
 * @summary updatePage
 */
export function updatePage(params: UpdatePageParams) {
  return request.put<AbstractResponse<ParPageResponse, unknown>>(
    `${URL}/api/pages/${params.pagcode}`,
    params.pageRequest
  );
}

export function updatePageComponent(params: UpdatePagComponentParams) {
  return request.put<AbstractResponse<ParPagComponentResponse, unknown>>(
    `${URL}/api/component`,
    params.request
  );
}

/**
 * @tags Fw Display Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface MoveMenusitemParams {
  isChild: boolean;
  itemid: number;
  itemidTarget: number;
  itemidTarget2: number;
}

/**
 * @tags Menus Item Controller
 * @summary MoveMenusitem
 */
export function MoveMenusitem(params: MoveMenusitemParams) {
  return request.put<AbstractResponse<MenusResponse, object>>(
    `${URL}/api/menus/menuitems/moveitem/${params.itemid}/${params.itemidTarget}/${params.itemidTarget2}` +
      prepareQueryParams({ isChild: params.isChild } as any)
  );
}



export interface GetPageSectionParams {
  comtype: string;
  pagcode?: string;
  pagmodule: string;
}


/**
 * @tags Fw Display Controller
 * @summary getPageSection
 */
export function getPageSection (params: GetPageSectionParams) {
  return request.get<AbstractResponse<ParPageResponse,object>>(`${URL}/api/pages/section` + prepareQueryParams({comtype: params.comtype, pagcode: params.pagcode, pagmodule: params.pagmodule} as any))
}

export interface GetParPageDetailParams {
  pagcode?: string;
};


/**
 * @tags New Display Controller
 * @summary getParPageDetail
 */
export function getParPageDetail (params: GetParPageDetailParams) {
  return request.get<AbstractResponse<NewParPageResponse,object>>(`${URL}/api/parpage/page/${params.pagcode}`)
};

export interface CreateParPageParams {
  pageRequest: NewParPageRequest;
};


/**
 * @tags New Display Controller
 * @summary createParPage
 */
export function createParPage (params: CreateParPageParams) {
  return request.post<AbstractResponse<NewParPageResponse,object>>(`${URL}/api/parpage/page`, params.pageRequest)
};


export interface UpdateParPageParams {
  pagcode?: string;
  pageRequest: NewParPageRequest;
};


/**
 * @tags New Display Controller
 * @summary updateParPage
 */
export function updateParPage (params: UpdateParPageParams) {
  return request.put<AbstractResponse<NewParPageResponse,object>>(`${URL}/api/parpage/page/${params.pagcode}`, params.pageRequest)
};

export interface GetParPagComponentByCriteriaParams {
  comcode: string;
  comlabel: string;
  comtype: string;
  pagcode?: string;
}


/**
 * @tags New Display Controller
 * @summary getParPagComponentByCriteria
 */
export function getParPagComponentByCriteria (params: GetParPagComponentByCriteriaParams) {
  return request.get<AbstractResponse<object,NewParPagComponentResponse>>(`${URL}/api/parpage/pagecomponent` + prepareQueryParams({comcode: params.comcode, comlabel: params.comlabel, comtype: params.comtype, pagcode: params.pagcode} as any))
}


export interface GetParPagComponentByComcodeParams {
  comcode: string;
};


/**
 * @tags New Display Controller
 * @summary getParPagComponentByComcode
 */
export function getParPagComponentByComcode (params: GetParPagComponentByComcodeParams) {
  return request.get<AbstractResponse<NewParPagComponentResponse,object>>(`${URL}/api/parpage/pagecomponent/comcode/${params.comcode}`)
};

export interface CreateParPageComponentParams {
  compRequest: NewParPagComponentRequest;
  pagcode?: string;
}


/**
 * @tags New Display Controller
 * @summary createParPageComponent
 */
export function createParPageComponent (params: CreateParPageComponentParams) {
  return request.post<AbstractResponse<NewParPagComponentResponse,object>>(`${URL}/api/parpage/pagecomponent/${params.pagcode}` + prepareQueryParams({pagcode: params.pagcode} as any), params.compRequest)
}

export interface UpdateParPageComponentParams {
  comcode: string;
  pagcode?: string;
  request: NewParPagComponentRequest;
}


/**
 * @tags New Display Controller
 * @summary updateParPageComponent
 */
export function updateParPageComponent (params: UpdateParPageComponentParams) {
  return request.put<AbstractResponse<NewParPagComponentResponse,object>>(`${URL}/api/parpage/pagecomponent/${params.pagcode}/${params.comcode}`, params.request)
}


export interface RemoveParPagComponentParams {
  comcode: string;
  pagcode?: string;
}


/**
 * @tags New Display Controller
 * @summary removeParPagComponent
 */
export function removeParPagComponent (params: RemoveParPagComponentParams) {
  return request.delete<AbstractResponse<object,object>>(`${URL}/api/parpage/pagecomponent/${params.pagcode}/${params.comcode}`)
}


export interface GetParPagFilteringListParams {
  pagcode?: string;
};


/**
 * @tags New Display Controller
 * @summary getParPagFilteringList
 */
export function getParPagFilteringList (params: GetParPagFilteringListParams) {
  return request.get<AbstractResponse<NewParPagFilteringResponse,object>>(`${URL}/api/parpage/pagfiltering/pagcode/${params.pagcode}`)
};

export interface GetParPagFilteringParams {
  filterid: number;
};


/**
 * @tags New Display Controller
 * @summary getParPagFiltering
 */
export function getParPagFiltering (params: GetParPagFilteringParams) {
  return request.get<AbstractResponse<NewParPagFilteringResponse,object>>(`${URL}/api/parpage/pagfiltering/${params.filterid}`)
};

export interface CreateParPagFilteringParams {
  pagcode?: string;
  req: NewParPagFilteringRequest;
};


/**
 * @tags New Display Controller
 * @summary createParPagFiltering
 */
export function createParPagFiltering (params: CreateParPagFilteringParams) {
  return request.post<AbstractResponse<NewParPagFilteringResponse,object>>(`${URL}/api/parpage/pagfiltering/${params.pagcode}` + prepareQueryParams({pagcode: params.pagcode} as any), params.req)
};

export interface UpdateParPagFilteringParams {
  filterid: number;
  pagcode?: string;
  req: NewParPagFilteringRequest;
}


/**
 * @tags New Display Controller
 * @summary updateParPagFiltering
 */
export function updateParPagFiltering (params: UpdateParPagFilteringParams) {
  return request.put<AbstractResponse<NewParPagFilteringResponse,object>>(`${URL}/api/parpage/pagfiltering/${params.pagcode}/filtering/${params.filterid}`, params.req)
}


export interface RemoveParPagFilteringParams {
  filterid: number;
};


/**
 * @tags New Display Controller
 * @summary removeParPagFiltering
 */
export function removeParPagFiltering (params: RemoveParPagFilteringParams) {
  return request.delete<AbstractResponse<object,object>>(`${URL}/api/parpage/filtering/${params.filterid}`)
};


export interface GetPagComFilteringParams {
  filterid: number;
  pagcode?: string;
}


/**
 * @tags New Display Controller
 * @summary getPagComFiltering
 */
export function getPagComFiltering (params: GetPagComFilteringParams) {
  return request.get<AbstractResponse<object,NewParPagComFilteringResponse>>(`${URL}/api/parpage/comfiltering/${params.pagcode}/${params.filterid}`)
}


export interface CreatePagComFilteringParams {
  filterid: number;
  pagcode?: string;
  request: NewParPagComFilteringRequest;
}


/**
 * @tags New Display Controller
 * @summary createPagComFiltering
 */
export function createPagComFiltering (params: CreatePagComFilteringParams) {
  return request.post<AbstractResponse<NewParPagComFilteringResponse,object>>(`${URL}/api/parpage/comfiltering/${params.pagcode}/${params.filterid}`, params.request)
}



export interface UpdatePagCFilteringParams {
  comfilterid: number;  
  request: NewParPagComFilteringRequest;
};


/**
 * @tags New Display Controller
 * @summary updatePagCFiltering
 */
export function updatePagCFiltering (params: UpdatePagCFilteringParams) {
  return request.put<AbstractResponse<NewParPagComFilteringResponse,object>>(`${URL}/api/parpage/comfiltering/${params.comfilterid}`, params.request)
};

export interface UpdatePagComFilteringParams {
  comfilterid: number;
  pagcode?: string;
  request: NewParPagComFilteringRequest;
};


/**
 * @tags New Display Controller
 * @summary updatePagComFiltering
 */
export function updatePagComFiltering (params: UpdatePagComFilteringParams) {
  return request.put<AbstractResponse<NewParPagComFilteringResponse,object>>(`${URL}/api/parpage/comfiltering/${params.pagcode}/${params.comfilterid}`, params.request)
};

export interface RemovePagCFilteringParams {
  comfilterid: number;
};


/**
 * @tags New Display Controller
 * @summary removePagCFiltering
 */
export function removePagCFiltering (params: RemovePagCFilteringParams) {
  return request.delete<AbstractResponse<object,object>>(`${URL}/api/parpage/comfiltering/${params.comfilterid}`)
};


export interface GetParPageByCriteriaParams {
  pagcode?: string;
  paglabel: string;
  pagmodule: string;
  pagurl: string;
}


/**
 * @tags New Display Controller
 * @summary getParPageByCriteria
 */
export function getParPageByCriteria (params: GetParPageByCriteriaParams) {
  return request.get<AbstractResponse<object,NewParPageResponse>>(`${URL}/api/parpage/pagecriteria` + prepareQueryParams({pagcode: params.pagcode, paglabel: params.paglabel, pagmodule: params.pagmodule, pagurl: params.pagurl} as any))
}

/**
 * @tags New Display Controller
 * @summary getParThemeList
 */
export function getParThemeList () {
  return request.get<AbstractResponse<object,ParTheme>>(`${URL}/api/parpage/theme`)
}

export interface CreateParThemeParams {
  themeRequest: ParTheme;
}


/**
 * @tags New Display Controller
 * @summary createParTheme
 */
export function createParTheme (params: CreateParThemeParams) {
  return request.post<AbstractResponse<ParTheme,object>>(`${URL}/api/parpage/theme`, params.themeRequest)
}

export interface UpdateParThemeParams {
  themeRequest: ParTheme;
  themeid: number;
}


/**
 * @tags New Display Controller
 * @summary updateParTheme
 */
export function updateParTheme (params: UpdateParThemeParams) {
  return request.put<AbstractResponse<ParTheme,object>>(`${URL}/api/parpage/theme/${params.themeid}`, params.themeRequest)
}